/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse20016 from '../model/InlineResponse20016';

/**
* StudentAcademicProgramsTitle service.
* @module api/StudentAcademicProgramsTitleApi
* @version 1.0.0
*/
export default class StudentAcademicProgramsTitleApi {

    /**
    * Constructs a new StudentAcademicProgramsTitleApi. 
    * @alias module:api/StudentAcademicProgramsTitleApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Upload academic program title payment document
     * Uploads the payment document required to obtain the academic degree certificate.
     * @param {Number} id Student Id
     * @param {File} file 
     * @param {Number} academicProgramId 
     * @param {Date} payedAt 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse20016} and HTTP response
     */
    uploadAcademicProgramTitleDocumentWithHttpInfo(id, file, academicProgramId, payedAt) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling uploadAcademicProgramTitleDocument");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling uploadAcademicProgramTitleDocument");
      }
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling uploadAcademicProgramTitleDocument");
      }
      // verify the required parameter 'payedAt' is set
      if (payedAt === undefined || payedAt === null) {
        throw new Error("Missing the required parameter 'payedAt' when calling uploadAcademicProgramTitleDocument");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': file,
        'academic_program_id': academicProgramId,
        'payed_at': payedAt
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse20016;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload academic program title payment document
     * Uploads the payment document required to obtain the academic degree certificate.
     * @param {Number} id Student Id
     * @param {File} file 
     * @param {Number} academicProgramId 
     * @param {Date} payedAt 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse20016}
     */
    uploadAcademicProgramTitleDocument(id, file, academicProgramId, payedAt) {
      return this.uploadAcademicProgramTitleDocumentWithHttpInfo(id, file, academicProgramId, payedAt)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
